// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__3Zf3w","header":"PatientBlock_header__3NXBf","label":"PatientBlock_label__RTapG","option":"PatientBlock_option__2E-sV"};